import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import icon from 'flarum/common/helpers/icon';

export default {
  view(vnode) {
    const translationPrefix = 'yingtao-forum-homepage.forum.hero';
    const cannotStartDiscussion = Boolean(app.session.user && !app.forum.attribute('canStartDiscussion'));

    return (
      <section className="Hero YingtaoHomeHero" aria-labelledby="yingtao-home-hero-title">
        <div className="container YingtaoHomeHero-inner">
          <div className="YingtaoHomeHero-copy">
            <p className="YingtaoHomeHero-kicker">Cherrymaker club</p>
            <h1 id="yingtao-home-hero-title">{app.translator.trans(`${translationPrefix}.title`)}</h1>
            <p>{app.translator.trans(`${translationPrefix}.subtitle`)}</p>
            <div className="YingtaoHomeHero-actions">
              <Button
                icon="fas fa-edit"
                className="Button Button--primary YingtaoButton YingtaoButton--publish"
                onclick={vnode.attrs.onStartDiscussion}
                disabled={cannotStartDiscussion}
              >
                {app.translator.trans(`${translationPrefix}.start_discussion`)}
              </Button>
              <LinkButton
                href={app.route('tag', { tags: 'showcase' })}
                icon="fas fa-cubes"
                className="Button YingtaoButton YingtaoButton--secondary"
              >
                {app.translator.trans(`${translationPrefix}.browse_showcase`)}
              </LinkButton>
            </div>
          </div>
          <div className="YingtaoHomeHero-mark" aria-hidden="true">
            <span>MAKE</span>
            {icon('fas fa-tools')}
          </div>
        </div>
      </section>
    );
  },
};
